module.exports = __webpack_public_path__ + "static/media/ic_key.b42171fc.svg";